import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import Button from '@mui/material/Button';
import { makeStyles } from '@material-ui/styles';
import DeleteIcon from '@mui/icons-material/Delete';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import FolderIcon from '@mui/icons-material/Folder';
import { maxWidth } from '@mui/system';
import ButtonBase from '@mui/material/ButtonBase';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from 'react-router-dom';


import secureAxios from '../../secureAxios';
import IBackdrop from '../backdrop.js';

import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  });
  
  
  const data = {
    "total":{"member":0,"stake":0},"direct":{"member":0,"stake":0}
  }

  const titles = ['Total referral', 'Direct referral'];
  const subTitle = ['members added in your team', 'members joined through direct referral']


  function generate(element) {
      return [0, 1, 2].map((value) =>
        React.cloneElement(element, {
          key: value,
        }),
      );
    }
  
    const Demo = styled('div')(({ theme }) => ({
      backgroundColor: 'transparent',
    }));
  
  
    const useStyles = makeStyles(theme => ({
      root: {
        height: '100%',
        borderBottomRightRadius: '40px',
        borderRadius: '5px'
      },
      content: {
        alignItems: 'center',
        display: 'flex'
      },
      title: {
        fontWeight: 'bold',
        color: 'rgb(33, 43, 54)'
      },
      subItemtitle: {
        color: '#eee',
        opacity: '0.5',
        fontSize: '8px'
      },
      
      icon: {
        height: 32,
        width: 32
      },
      cardBackground: {
        backgroundColor: '#f0f5f9',
        maxWidth: '300px'
        //padding: 2
      },
      progressBar:{
        width: '50%',
        maxWidth: '200px',
        margin: 'auto'
      },
      pan: {
        boxShadow:  'rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px;',
        transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;',
        background: 'rgb(255, 255, 255)'
      }
    }));

    const text = {
        color: "rgb(33, 43, 54)",
        opacity: '0.7',
        fontSize: '11px',
        maxWidth: '250px'
    };

    const subItemtitle = {
      color: 'rgb(33, 43, 54)',
      fontSize: '13px'
    };
  
  const Users = (props) => {
      const { className, tileDilogue, onClicked, ...rest } = props;
      const classes = useStyles();
      const [dense, setDense] = React.useState(false);
      const [secondary, setSecondary] = React.useState(false);

      const [open, setOpen] = React.useState(false);
      const [statements, setStatements] = React.useState(data);

      useEffect(() => {
        window.scrollTo(0, 0)
      }, []);

      const memberDetails = () => {
        setOpen(true);
        secureAxios
            .get(`${process.env.REACT_APP_SERVICE_PYTHON_API_URL}/user/team/info`).then(response => {
              setOpen(false);
              
              setStatements(response.data);
              
            }).catch(error => {
              setOpen(false);
              if (error.response.data?.non_field_errors){
                alert(error.response.data?.non_field_errors)
              }
              else{
                alert(error.response.data?.detail)
              }
    
            })
      }

      React.useEffect(() => {
        memberDetails()
        return
      }, []);


      
      return (
      <>
      <IBackdrop isOpen={open} msg={"Signin progress"}/>
      {Object.keys(statements).map((item, index) => {
        return (
            <Paper key={index}
            className={classes.pan}
            style={{background: 'rgb(24, 26, 32)'}}
                sx={{
                p: 2,
                margin: 'auto',
                maxWidth: 500,
                marginTop: index !== 0 ? '10px': 0,
                marginBottom: index == Object.keys(statements).length - 1 ? '70px' : 0,
                flexGrow: 1
                }}
            >
                <Grid container spacing={2}>
                <Grid item xs={12} sm container>
                    <Grid item xs container direction="column" spacing={2}>
                    <Grid item xs>
                        <Demo>
                            <List dense={dense}>
                                <ListItem
                                    secondaryAction={
                                    <IconButton edge="end" aria-label="delete">
                                        <Link to={"/teamoverview/"+item}>
                                        <KeyboardArrowRightIcon style={{color: 'rgb(33, 43, 54)'}}/>
                                        </Link>
                                    </IconButton>
                                    }
                                >
                                    <ListItemText
                                    className={classes.title}
                                    primary={titles[index] + " - " +statements[item].member}
                                    secondary={`Total Stake Amount - ${parseFloat(statements[item].stake).toFixed(6)}`}
                                    secondaryTypographyProps={{style: text}}
                                    />
                                </ListItem>
                                
                            </List>
                        </Demo>
                    </Grid>
                    </Grid>
                </Grid>
                </Grid>
            </Paper>
            )
        })}
      </>
      
      )
  }
  
  export default Users

